import { Fragment, useCallback, useEffect } from "react"

declare global {
  interface Window {
    dataLayer: Record<string, string>[]
  }
}

const sendGAEvent = (eventName: string, objectValue: string, label: string) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: eventName,
    object: objectValue,
    label: label
  })
}

export const GoogleAnalytic = () => {
  const handleGlobalClick = useCallback((event: MouseEvent) => {
    const clickedElement = event.target as HTMLElement
    const targetElement = clickedElement.closest("[data-action]")

    if (!targetElement) return
    const action = targetElement.getAttribute("data-action")

    if (action) {
      const event = targetElement.getAttribute("data-event") ?? ""
      const value = targetElement.getAttribute("data-value") ?? ""
      const label = targetElement.getAttribute("data-label") ?? ""
      sendGAEvent(event, value, label)
    }
  }, [])

  useEffect(() => {
    window.addEventListener("click", handleGlobalClick)
    return () => {
      window.removeEventListener("click", handleGlobalClick)
    }
  }, [handleGlobalClick])

  return <Fragment />
}
